import { el } from './dom';
import { CONSENT_SENTENCE, LEGAL_LINKS } from '../config/legal';

/**
 * The four-point summary, shown where the player is deciding rather than
 * buried in the policy they will not open.
 */
export function consentNote(): HTMLDivElement {
  return el('div', { className: 'account-consent', testid: 'account-consent' }, CONSENT_SENTENCE);
}

/**
 * Links to the published documents. target=_blank on purpose: a half-filled
 * signup form must survive someone reading the terms.
 */
export function legalLinkRow(): HTMLDivElement {
  const row = el('div', { className: 'account-legal', testid: 'account-legal' });
  LEGAL_LINKS.forEach((link, i) => {
    if (i) row.append(document.createTextNode(' · '));
    row.append(
      el('a', { href: link.href, target: '_blank', rel: 'noopener noreferrer' }, link.label),
    );
  });
  return row;
}
